export const sizes = [
    { option: "notApplicable", label: "Not Applicable" },
    { option: "0-3 Months", label: "0-3 Months" },
    { option: "3-6 Months", label: "3-6 Months" },
    { option: "6-9 Month", label: "6-9 Months" },
    { option: "9-12 Months", label: "9-12 Months" },
    { option: "12-18 Months", label: "12-18 Months" },
    { option: "18-24 Months", label: "18-24 Months" },
    { option: "2-3 Years", label: "2-3 Years" },
    { option: "3-4 Years", label: "3-4 Years" },
    { option: "4-5 Years", label: "4-5 Years" },
    { option: "5-6 Years", label: "5-6 Years" },
    { option: "6-7 Years", label: "6-7 Years" },
    { option: "7-8 Years", label: "7-8 Years" },
    { option: "8-9 Years", label: "8-9 Years" },
    { option: "9-10 Years", label: "9-10 Years" },
    { option: "a10 Years+", label: "10 Years+" },
    { option: "Baby: 0 - 2 Years", label: "Baby: 0 - 2 Years" },
    { option: "Toddler: UK 6 - 11", label: "Toddler: UK 6 - 11" },
    { option: "Little Kid: UK 11 - 2", label: "Little Kid: UK 11 - 2" },
    { option: "Big Kid: UK 3 - 6", label: "Big Kid: UK 3 - 6" },
    { option: "8-10", label: "8-10" },
    { option: "10-12", label: "10-12" },
    { option: "12-14", label: "12-14" },
    { option: "14-16", label: "14-16" },
    { option: "16-18", label: "16-18" },
    { option: "18-20", label: "18-20" },
    { option: "20-22", label: "20-22" },

    { option: "Small", label: "Small" },
    { option: "Medium", label: "Medium" },
    { option: "Large", label: "Large" },
    { option: "X Large", label: "X Large" },

]



